import { LoginByPasswordFooterProps } from '@shopee-user/business-customization-types';

export default function LoginByPasswordFooter(_: LoginByPasswordFooterProps) {
  return null;
}
